import axios from 'axios';
import WebApiService from '../services/WebApiService';

export default class BroadcastService extends WebApiService {

    constructor() {
        super();

        this.post = super.post.bind(this);
        this.get = super.get.bind(this);
    }

    blast(data, successCallback, errorCallback) {
        this.post('/api/Broadcast/Blast', data, successCallback, errorCallback);
    }

    groupsBlast(data, successCallback, errorCallback) {
        this.post('/api/Broadcast/GroupsBlast', data, successCallback, errorCallback);
    }

    stackup(data, successCallback, errorCallback) {
        this.post('/api/Stackup/Data', data, successCallback, errorCallback);
    }

    blastLongitude(data, successCallback, errorCallback) {
        this.post('/api/Broadcast/BlastLongitude', data, successCallback, errorCallback);
    }
}